import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeGetCompanyClusterSnapshotsResponseDataSchema, DataResponse } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof BackofficeGetCompanyClusterSnapshotsResponseDataSchema>>

const getBackofficeClusterSnapshotsQueryKey = (companyId: string, canonicalTopicId: string) => [
  "backofficeClusterSnapshots",
  companyId,
  canonicalTopicId,
]

type Props = {
  companyId: string
  canonicalTopicId: string
}

export const getBackofficeClusterSnapshotsQuery = ({ companyId, canonicalTopicId }: Props) => {
  return queryOptions({
    queryKey: getBackofficeClusterSnapshotsQueryKey(companyId, canonicalTopicId),
    queryFn: async () => {
      const { data } = await axios.get<Response>(
        `/backoffice/canonicalTopics/${canonicalTopicId}/snapshots`,
        { params: { companyId } },
      )

      return data.data
    },
    enabled: !!canonicalTopicId,
  })
}
